/** Clickable 1–5 star input. */
function StarRatingInput({ value, onChange, disabled }) {
  const v = Math.min(5, Math.max(0, Math.round(Number(value) || 0)));
  return (
    <div className="star-rating-input d-flex gap-1 align-items-center" role="group" aria-label="Your star rating">
      {[1, 2, 3, 4, 5].map((s) => (
        <button
          key={s}
          type="button"
          disabled={disabled}
          className={`star-rating-input__star ${v >= s ? "star-rating-input__star--on" : ""}`}
          onClick={() => onChange(s)}
          aria-pressed={v === s}
          aria-label={`${s} star${s > 1 ? "s" : ""}`}
        >
          ★
        </button>
      ))}
      <span className="small text-muted ms-1">{v > 0 ? `${v} / 5` : "Tap stars"}</span>
    </div>
  );
}

export default StarRatingInput;
